import { IListApiRequest, IListApiResponse } from 'api/types'

export enum EnquiryStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED'
}
export type UserEnquiry = {
  id: number,
  status: string
}

export interface Enquiries {
  id?: number;
  fullname?: string;
  subsId?: number;
  fullName: string;
  mobile: string;
  email: string;
  message: string;
  status?: EnquiryStatus;
  userDTO: {
    id: number
  };
}
export type EnquirySaveRequest = {
  enquiryDTO: Enquiries
}

export type EnquiryListRequest = IListApiRequest<Enquiries>
export type EnquiryListResponse = IListApiResponse<Enquiries>
